<template>
  <div class="row">
    <GenericProps
      :node-id="node.id"
      :settings.sync="settings"
      :audio-parameters="audioParameters"
      :parameters="filteredNodeParameters"
      @update:settings="updateNodeParent"
    />
  </div>
</template>

<script>
import nodePropsMixin from '@/modules/ivrs/mixins/nodePropsMixin';
import { merge } from 'lodash';
import { mapState } from 'vuex';
import {
  createSettingsHierarchy,
  getFieldError,
  getFieldSize,
} from '../../../../helpers/node';

const legacyGatherParameters = [ 'prompt', 'gatherTagName', 'numberOfDigits', 'minNumberOfDigits', 'validDigits', 'finishOnKey', 'timeOutInSeconds', 'timeOutBetweenKeyPressInSeconds', 'retries'];
const ivrGatherParameters = ['voiceResponse', 'dataConfirmation', 'valueToCapture', 'prompt', 'gatherTagName', 'retries', 'timeOutInSeconds'];
const ivrGatherLegacyParameters = [ 'voiceResponse', 'prompt', 'gatherTagName', 'numberOfDigits', 'minNumberOfDigits', 'validDigits', 'finishOnKey', 'timeOutInSeconds', 'timeOutBetweenKeyPressInSeconds', 'retries'];
const ivrGatherNumberCaptureParameters = ['voiceResponse', 'dataConfirmation', 'valueToCapture', 'prompt', 'gatherTagName', 'numberOfDigits', 'minNumberOfDigits', 'retries', 'timeOutInSeconds'];
const ivrGatherNumberCaptureDataConfirmationParameters = ['voiceResponse', 'dataConfirmation', 'valueToCapture', 'prompt', 'gatherTagName', 'numberOfDigits', 'minNumberOfDigits', 'retries', 'timeOutInSeconds', 'wholeNumberConfirmation'];

export default {
  name: 'GatherNodeProps',

  mixins: [nodePropsMixin],

  data() {
    return {
      audioParameters: Object.freeze(['prompt'])
    };
  },

  computed: {
    ...mapState({
      featureFlags: 'currentAccountFeatureFlags'
    }),
    
    ivrGatherFeatureFlag() {
      return this.featureFlags.ivr_gather;
    },

    filteredNodeParameters() {
      return this.buildFilteredParameters();
    }
  },
  
  watch: {
    node() {
      this.buildNodeSettings();
    },
  },

  created() {
    this.buildNodeSettings();
  },

  methods: {
    getFieldError,

    getFieldSize,

    buildFilteredParameters() {
      // if ivr gather flag is set but voice response is unset, use legacy gather parameters
      if (this.ivrGatherFeatureFlag && !this.settings.voiceResponse) {
        return this.node.parameters.filter((parameter) => ivrGatherLegacyParameters.includes(parameter.name)); 
      } else if (this.ivrGatherFeatureFlag && this.settings.voiceResponse && this.settings.valueToCapture === 'PIN') {
        if (this.settings.dataConfirmation) {
          return this.checkDataConfirmation(this.node.parameters.filter((parameter) => ivrGatherNumberCaptureDataConfirmationParameters.includes(parameter.name)));
        }
        return this.checkDataConfirmation(this.node.parameters.filter((parameter) => ivrGatherNumberCaptureParameters.includes(parameter.name)));
      } else if (this.ivrGatherFeatureFlag && this.settings.voiceResponse) {
        // if ivr gather flag is set and voice response is set, use ivr gather parameters
        return this.checkDataConfirmation(this.node.parameters.filter((parameter) => ivrGatherParameters.includes(parameter.name)));
      }  else { // if ivr gather flag is not set, use legacy parameters
        return this.node.parameters.filter((parameter) => legacyGatherParameters.includes(parameter.name));
      }
    },

    checkDataConfirmation(parameters) {
      // check if Play file is enabled in Node, or, Say is enabled AND the Telnyx voice is being used. 
      // Data confirmation is disabled for Yes/No capture as users cannot confirm boolean responses
      // in these cases Data confirmation is not possible to be enabled nor is whole number
      if (
        this.settings.prompt.play.isEnabled || this.settings.valueToCapture === 'BOOLEAN' ||
        (this.settings.prompt.say.isEnabled && (this.settings.prompt.say.voice === 'WOMAN' || (this.settings.prompt.say.voice === 'MAN')))
      ) {
        return parameters.filter((parameter) => parameter.name !== 'dataConfirmation' && parameter.name !== 'wholeNumberConfirmation');
      } 
      return parameters;
    },
    
    buildNodeSettings() {
      // Sets value of settings data
      this.settings = createSettingsHierarchy(this.node, undefined, undefined, this.node.settings);

      // Merges built settings hierarchy with current node settings
      this.settings = merge(this.settings.root, this.node.settings);

      this.handleMessage(this.settings.prompt);

      this.updateNodeParent();
    },
    handleMessage(settings) {
      if (settings.play.URL) {
        settings.isEnabled = true;
        settings.play.isEnabled = true;
      }
      if (settings.say.text) {
        settings.isEnabled = true;
        settings.say.isEnabled = true;
      }
    },
  },
};
</script>

<style>
</style>